import React from "react";
import { Link } from "react-router-dom";
import Home from "../../../../src/common/assets/data/home/index";
import Section from "../ui-components/section";
import Container from "../ui-components/container";
function Footer() {
  const data = Home.FooterSection;
  return (
    <footer className="bg-grid">
      <Section>
        <Container>
          <div className="grid grid-cols-1 sm:grid-cols-5 gap-5">
            <div className="col-span-2">
              <Link href="/">
                <div className=" bg-white rounded-full w-[95px] h-[95px]">
                <img src={data.logo.light_logo} alt="" className="p-3  rounded-full" />
                </div>
              </Link>
              <p className="text-base md:text-lg mt-2 text-white">{data.paragraph}</p>
            </div>
            <div className="col-span-3 text-white">
              <div className="md:grid grid-flow-col md:grid-flow-row">
                <div className="md:grid  grid-cols-1 md:grid-cols-3 gap-4">
                  {data.quickLinks.map((items,index) => (
                    <div className="pl-5 pb-5 md:border-l-white md:border-l" key={index+1}>
                      <h5 className="font-semibold text-lg md:text-xl mb-2">{items.id}</h5>
                      <ul>
                        {items.links.map((list,index) => (
                          <div key={index+1}>
                          {(list.label == "Privacy Policies"|list.label === "Terms and Conditions")? (<li className=" text-sm md:text-lg">
                            <Link to={list.path}>{list.label}</Link>
                          </li>):(
                            <li className="text-sm md:text-lg" >
                            <Link to={list.path}>{list.label}</Link>
                          </li>
                          )}
                          </div>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
                <div className=" md:grid  grid-cols-1 md:grid-cols-2">
                  {data.socialIcons.map((social,index) => (
                    <div key={index+1}className="pl-5 pt-5 md:border-t md:border-t-white md:border-l-white md:border-l">
                      <h5 className="font-bold text-xl mb-2">{social.id}</h5>
                      <ul className="flex gap-4 ">
                        {social.links.map((list) => (
                          <li className="">
                            <Link to={list.path} target="_blank">
                              <img  src={list.icon} width={list.width} />
                            </Link>
                          </li>
                        ))} 
                      </ul>
                    </div>
                  ))}
                  {/* <h3 className="text-white mt-4">Sales</h3> */}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Section>
      <Container>
        <div className="flex  justify-center text-white border-t text-sm md:text-lg">
          <p className="py-5">
            Copyright &#169; 2023 Vaidyo Powered By Finsol Consultancy Private Limited. All Right
            Reserved
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
